function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "COM-4258",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "error_outline_black"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  x: 0,
  y: 0,
  width: 32,
  height: 32
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.6666667,20 L18.3333333,20 L18.3333333,22.6666667 L15.6666667,22.6666667 L15.6666667,20 Z M15.6666667,9.33333333 L18.3333333,9.33333333 L18.3333333,17.3333333 L15.6666667,17.3333333 L15.6666667,9.33333333 Z M16.9866667,2.66666667 C9.62666667,2.66666667 3.66666667,8.64 3.66666667,16 C3.66666667,23.36 9.62666667,29.3333333 16.9866667,29.3333333 C24.36,29.3333333 30.3333333,23.36 30.3333333,16 C30.3333333,8.64 24.36,2.66666667 16.9866667,2.66666667 Z M17,26.6666667 C11.1066667,26.6666667 6.33333333,21.8933333 6.33333333,16 C6.33333333,10.1066667 11.1066667,5.33333333 17,5.33333333 C22.8933333,5.33333333 27.6666667,10.1066667 27.6666667,16 C27.6666667,21.8933333 22.8933333,26.6666667 17,26.6666667 Z",
  id: "Shape",
  fill: "#EC655E",
  fillRule: "nonzero"
})));

function SvgErrorOutlineBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "error_outline_black") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorOutlineBlack);
export default __webpack_public_path__ + "static/media/error_outline_black.5835d812.svg";
export { ForwardRef as ReactComponent };